import { render, staticRenderFns } from "./LibraryEmptyState.vue?vue&type=template&id=0840252c&scoped=true"
import script from "./LibraryEmptyState.vue?vue&type=script&lang=js"
export * from "./LibraryEmptyState.vue?vue&type=script&lang=js"
import style0 from "./LibraryEmptyState.vue?vue&type=style&index=0&id=0840252c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0840252c",
  null
  
)

export default component.exports